module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "f-scrolltop",
    attrs: {
      "data-threshold": _vm.threshold
    },
    on: {
      "click": _vm.onClickHandle
    }
  }) : _vm._e()
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0256c586", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0256c586!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/scrolltop/scrolltop.vue
// module id = 7
// module chunks = 0